import * as SliderPrimitive from "@radix-ui/react-slider";
import React from "react";

export const LevaregSlider = React.forwardRef(
  ({ className, ...props }, ref) => (
    <SliderPrimitive.Root
      ref={ref}
      className={"pr d-flex w-100 ai-center"}
      style={{ touchAction: "none", userSelect: "none" }}
      {...props}
    >
      <SliderPrimitive.Track
        className="pr  w-100 "
        style={{
          borderRadius: "9999px",
          flexGrow: 1,
          height: "0.5rem",
          background: "#c04040ff",
        }}
      >
        <SliderPrimitive.Range
          className="position-absolute h-100"
          style={{ background: "#40c057" }}
        />
      </SliderPrimitive.Track>

      <SliderPrimitive.Thumb className="d-block sliderThumb" />
    </SliderPrimitive.Root>
  )
);
LevaregSlider.displayName = SliderPrimitive.Root.displayName;
